export default "__VITE_ASSET__B3U3YEer__"